import React from 'react'
import agent from "../../agent";
import {
  GOAL_SET_STATE,
  LOGO_SET_STATE,
  NAME_SET_STATE,
  ROLE_SET_STATE,
  TEAM_OVERVIEW_STATE,
  TUTORIAL_SET_STATE,
  VALUES_SET_STATE,
  WELCOME_STATE
} from "../../constants/Constants";
import User_LeftPanel from "./User_LeftPanel";
import User_SetNameState from "./UserPanelStates/User_SetNameState";
import UtilsFunctions from "../../utils/UtilsFunctions";
import User_SetLogoState from "./UserPanelStates/User_SetLogoState";
import User_SetRoleState from "./UserPanelStates/SetRoleState/User_SetRoleState";
import Gameplay from "../Gameplay";
import User_WelcomeState from "./UserPanelStates/User_WelcomeState";
import User_SetGoalState from "./UserPanelStates/User_SetGoalState";
import User_ValuesState from "./UserPanelStates/User_ValuesState";
import User_TutorialState from "./UserPanelStates/User_TutorialState";
import User_TeamOverviewState from "./UserPanelStates/User_TeamOverviewState";

class UserPanel extends React.Component {
  constructor() {
    super();
    this.state = {
      game_info: null, goals: ["", "", ""], values: ["", "", "", "", ""]
    };

    this.readGameHeartbeat = null;
    this.lastDataChange = null;
  }

  componentDidMount() {
    this.readGame();
    this.readGameHeartbeat = setInterval(this.checkGameStatus.bind(this), 2000)
  }

  componentWillUnmount() {
    console.log('unmount')
    clearInterval(this.readGameHeartbeat);
  }

  openTeamZoom() {
    console.log("team zoom")
    let game = this.state.game_info;
    agent.Integrations.getTeamZoom(game.currentPlayer.teamID, (response) => {
      console.log(response)
      window.open(response.url, "_blank")
    });
  }

  callModerator() {
    console.log("call moderator");
    let game = this.state.game_info;
    agent.Team.callModerator(game.currentPlayer.teamID, response => {
      console.log(response);
    });
  }

  openGeneralZoom() {
    let game = this.state.game_info;
    agent.Integrations.getGeneralZoom(game.uuid, (response) => {
      window.open(response.url, "_blank")
    });
  }

  checkGameStatus() {
    agent.Game.gameStatus(this.props.gameId, response => {
      if (this.lastDataChange === null || this.lastDataChange.last_changed !== response.last_changed) {
        this.readGame();
      }
      this.lastDataChange = response;
    })
  }

  readGame(onFinish) {
    agent.Game.readGame(this.props.gameId, (response) => {
      window.teamID = response.currentPlayer.teamID;

      let currentTeam = UtilsFunctions.getTeamById(response.teams, response.currentPlayer.teamID);
      this.setState({
        game_info: response,
        goals: currentTeam.goals.goals ?? ["", "", ""],
        values: currentTeam.values.teamValues ?? ["", "", "", "", ""]
      });

      if (onFinish) {
        onFinish()
      }
    });
  }

  handleError(message) {
    this.props.onError(message);
  }

  render() {
    let game = this.state.game_info;

    if (!game) return "";
    if (!game.is_started) {
      this.props.showWaitGameDialog();
      return;
    }
    let currentTeam = UtilsFunctions.getTeamById(game.teams, game.currentPlayer.teamID);
    if (!currentTeam) return "";
    let panel = "";

    UtilsFunctions.getPlayerRoles = () => game.currentPlayer.role;

    switch (currentTeam.state) {
      case WELCOME_STATE:
        panel = <User_WelcomeState/>
        break;
      case NAME_SET_STATE:
        console.log('Show set name panel')
        panel = <User_SetNameState teamname={currentTeam.name}/>
        break;
      case LOGO_SET_STATE:
        panel = <User_SetLogoState game={game} team={currentTeam} player={game.currentPlayer}
                                   onError={this.handleError.bind(this)}/>
        break;
      case ROLE_SET_STATE:
        panel = <User_SetRoleState parent={this} team={currentTeam} player={game.currentPlayer}
                                   onError={this.handleError.bind(this)}/>
        break;
      case GOAL_SET_STATE:
        panel = <User_SetGoalState goals={this.state.goals} team={currentTeam} updateGoals={(data) => {
          this.setState({goals: data})
        }}/>;
        break;
      case VALUES_SET_STATE:
        panel = <User_ValuesState values={this.state.values} team={currentTeam} updateValues={(data) => {
          this.setState({goals: data})
        }}/>;
        break;
      case TEAM_OVERVIEW_STATE:
        panel = <User_TeamOverviewState team={currentTeam}/>;
        break;
      case TUTORIAL_SET_STATE:
        panel = <User_TutorialState/>;
        break;
      default:
        panel = <Gameplay openDictionaryAt={this.props.openDictionaryAt} width={window.innerWidth - 60}
                          height={window.innerHeight - 60} teamID={game.currentPlayer.teamID}
                          currentRole={game.currentPlayer.role}
                          gameId={this.props.gameId}/>;
        break;
    }
    return <div>
      <div className={'user-panel-container'}>
        {panel}
      </div>
      <User_LeftPanel
        onGeneralZoom={this.openGeneralZoom.bind(this)}
        onCallModerator={this.callModerator.bind(this)}
        onTeamZoom={this.openTeamZoom.bind(this)}/>
    </div>
  }
}

export default UserPanel;
